import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "../../style";
import SeeMore from "../../../shared/SeeMore";
import { useNewOfferMobile } from "../../../context";
import InputForm from "../../../../../../shared/atoms/InputForm";

const CreditCardCvvInput = ({ step, creditCardData, onChangeCreditCardData }) => {
	const { setStepError } = useNewOfferMobile();

	const details = creditCardData.data.details;

	const [state, setState] = useState({
		cvv: creditCardData.data.cvv || "",
		hasError: creditCardData.data.cvv && creditCardData.data.cvv.length !== details.code.size
	});

	useEffect(() => {
		setStepError(!state.cvv.length || state.hasError);
	}, [state]);

	const onChange = event => {
		const { name, value } = event.target;
		const cvv = String(value).replace(/[^0-9.]/g, "");

		setState({
			...state,
			[name]: cvv,
			hasError: !cvv.length || !details || details.code.size !== cvv.length
		});

		onChangeCreditCardData({ cvv: cvv });
	};

	return (
		<div
			className={css`
                ${stepContent};
            `}
		>
			<strong
				className={css`
                    ${header};
                `}
			>
				Dados do cartão             
			</strong>
			<div
				className={css`
                    ${singleInput};
                `}
			>
				<InputForm
					name="cvv"
					id="cvv"
					type="tel"
					value={state.cvv}
					onChange={onChange}
					label="CVV"
					errorMessage="Código inválido"
					maxLength={details ? details.code.size : 4}
					hasError={state.hasError}
					data-action="register-credit-card-security-code"
				/>
			</div>

			<SeeMore>
				<strong>Por que precisamos dos dados do seu cartão?</strong>
				<p>
					Para emitir passagens em companhias internacionais, o pagamento das taxas e encargos deve
					ser feito no cartão de crédito do mesmo titular das milhas.                 
				</p>

				<p>Por isso, cadastre os dados corretos do cartão.</p>

				<p>
					<strong>Sigilo e segurança dos seus dados</strong>
				</p>

				<p>
					Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
					segurança. Aqui, seus dados estão protegidos.
				</p>
			</SeeMore>
		</div>
	);
};

export default CreditCardCvvInput;
